import { getUserPermissionForFolderId } from 'owa-mail-store';
import { getStore } from 'owa-mail-store/lib/store/Store';
import ItemId from 'owa-service/lib/contract/ItemId';
import { getUserEmailAddress } from 'owa-session-store';
import {
    getFolderTable,
    isFolderOfTreeType,
    Permission,
    SHARED_FOLDERS_TREE_TYPE,
} from 'owa-folders';

export function getIsInSharedFolder(itemId: ItemId): boolean {
    const folderId = getFolderIdFromItemId(itemId);

    if (!folderId) {
        return false;
    }

    return isFolderOfTreeType(folderId, SHARED_FOLDERS_TREE_TYPE);
}

export function getFolderOwnerEmailAddress(itemId: ItemId): string {
    const folderId = getFolderIdFromItemId(itemId);

    if (!folderId) {
        return null;
    }

    const folder = getFolderTable().get(folderId);
    return folder ? folder.principalSMTPAddress : null;
}

export function getFolderPermission(itemId: ItemId): Permission {
    const folderId = getFolderIdFromItemId(itemId);

    if (!folderId) {
        return null;
    }

    const userEmail = getUserEmailAddress();
    const folderPermission = getUserPermissionForFolderId(folderId, userEmail);

    return folderPermission;
}

function getFolderIdFromItemId(itemId: ItemId) {
    if (!itemId) {
        return null;
    }

    const item = getStore().items.get(itemId.Id);
    return item && item.ParentFolderId && item.ParentFolderId.Id;
}
